module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderPage"
    }
  }, [_c('div', {
    staticClass: "help"
  }, [_c('span', {
    staticClass: "help-icon",
    on: {
      "click": function($event) {
        _vm.helpCliked()
      }
    }
  }, [(!_vm.help_cliked) ? _c('i', {
    staticClass: "icon-question-sign"
  }) : _vm._e(), _vm._v(" "), (_vm.help_cliked) ? _c('i', {
    staticClass: "icon-circledelete"
  }) : _vm._e()]), _vm._v(" "), (_vm.help_cliked) ? _c('div', {
    staticClass: "help_information"
  }, [_c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("振替依頼をする場合")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.$router.push('/table')
      }
    }
  }, [_vm._v("\n    座席予約表トップへ\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("座席予約表へログイン後、画面左上の「振替を依頼する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("画面の指示に従い、入力を進める")]), _vm._v(" "), _c('ol', {
    staticClass: "helpO2"
  }, [_c('li', [_vm._v("①振替を希望する授業をリストから選択")]), _vm._v(" "), _c('li', [_vm._v("②振替候補日時を選択")]), _vm._v(" "), _c('li', [_vm._v("③振替を希望する理由を入力")]), _vm._v(" "), _c('li', [_vm._v("（講師のみ、④振替後の授業の情報を入力）")])]), _vm._v(" "), _c('li', [_vm._v("入力項目を確認し、「振替依頼をする」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("完了画面を確認し、「座席表トップへ」をクリック")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("振替依頼をしたあとは・・・")]), _vm._v(" "), _c('p', [_vm._v("24時間以内に振替の承認・不承認の結果がメールで届きます。"), _c('br'), _vm._v("\n  \t\t\t\t承認された場合は、そのまま振替後の日時に教室にお越しください。"), _c('br'), _vm._v("\n  \t\t\t\t不承認された場合は、承認者から別の振替候補日時が提案されますので、再度振替依頼を行ってください。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f694aac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReschedulingPage/ReschedulingSenderPage.vue
// module id = 730
// module chunks = 0